import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountsAlerts} from "../../../account/services/accounts-alerts.service";
import {AccountDialogService} from "../../../account/services/account-dialogs-service.service";
import {$accountsFactory} from "../../../account/$accounts.factory";
import {$accountFactory} from "../../../account/$account.factory";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {BranchModel} from "../../models/branch.model";
import {DepotReferenceModel} from "../../../depots/angular/models/depot-reference.model";
import {AccountsService} from "../../../account/services/accounts-service.service";
import {AccountModel} from "../../../account/angular/models/account.model";

export class branchesShipperAccountsViewCtrl implements IController {

  branch: BranchModel;

  private loadLimit = 30;
  private accountsRef: any;
  private infiniteScroll: any;
  private accountIds = [];
  private type = undefined;
  private queryString = undefined;
  private canRemove: boolean;

  /* @ngInject */
  constructor(private accountDialogService: AccountDialogService, private IAMPermissions, private accountsAlerts: AccountsAlerts,
              private $log, private bringozLoaderService: BringozLoaderService, private $account: $accountFactory, private $accounts: $accountsFactory,
              private $shippers, private confirmDialogService: ConfirmDialogService, private $infiniteScroll, private accountsService: AccountsService) {
  }

  $onInit() {
    this.canRemove = this.IAMPermissions.hasPermission('accounts.demand.update');
    this.accountsRef = this.$accounts();
    this.accountsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.accountsRef, this.loadLimit);
    this.accountsRef.$getAll(this._getInitQueryPayload()).then((accountIds) => {
      this.accountIds = accountIds;
    })
  }

  onQueryChange(query) {
    this.queryString = query;
    this._query();
  }

  onInviteAccount(event) {
    this.accountDialogService.addShipperAccount(event, this.accountIds)
      .then((accountIds) => {
        const ids: string[] = _.difference(accountIds, this.accountIds);
        this._updateAccounts(ids, [this.branch.id]);
      })
  }

  onCreateAccountToBranch(event) {
    this.accountDialogService.createShipperAccount(event, this.branch.id)
      .then((createdAccount) => {
        return this.accountsRef.$getAll(this._getQueryPayload());
      })
      .then((updatedAccountIds) => {
        this.accountIds = updatedAccountIds;
        this._query();
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to get shipper accounts in branch ' +
            '@branchesShipperAccountsView@onCreateAccountToBranch', error);
        } else {
          this.$log.info('Dialog Closed')
        }
      })
  }

  onRemoveAccount(account, event) {
    let loading = false;
    this.confirmDialogService.confirm('Remove Account', 'Are you sure you want to remove this account from branch?', event)
      .then(() => {
        let accountCopy = angular.copy(account);
        accountCopy.branchIds = _.without(account.branchIds, this.branch.id);

        loading = true;
        this.bringozLoaderService.on();
        return this.$account(account.id).$update(accountCopy);
      })
      .then((updatedAccount) => {
        this.accountsAlerts.demandRemoveFromBranchSuccess(updatedAccount);
        return this.accountsRef.$getAll(this._getQueryPayload());
      })
      .then((updatedAccountIds) => {
        this.accountIds = updatedAccountIds;
        this._query();
      })
      .catch((error) => {
        if (error) {
          this.accountsAlerts.demandRemoveFromBranchError();
          this.$log.info('Failed to remove account from branch ' +
            '@branchesShipperAccountsView@onRemoveAccount', event);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        if (loading) {
          this.bringozLoaderService.off();
        }
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  private _updateAccounts(accountIds, branchIds) {
    this.accountsService.addBranches(accountIds, branchIds)
      .then((updatedAccounts: AccountModel[]) => {
        _.forEach(updatedAccounts, (account: AccountModel) => {
          this.accountIds.push(account.id);
        })
        this._query();
      })
  }

  private _query() {
    this.accountsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Fail to $query', error);
        }
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      isDemand: true,
      type: this.type,
      query: this.queryString,
      branchIds: [this.branch.id]
    };
  }

  private _getInitQueryPayload() {
    return {
      isDemand: true,
      type: this.type,
      query: this.queryString,
      branchIds: [this.branch.id]
    };
  }

}

angular.module('bringoz.admin.branches')
  .component('branchesShipperAccountsView', {
    bindings: {
      branch: '<'
    },
    template: require('./branches-shipper-accounts-view.html').default,
    controller: branchesShipperAccountsViewCtrl
  });
